// extracted by mini-css-extract-plugin
export var container = "_e3-0";
export var icon = "_e3-1";
export var text = "_e3-2";